import styled, { css } from 'styled-components'
import IconAguardandoEntrega from '../../assets/img/inativo.png'
import IconEntregaEfetuada from '../../assets/img/ativo.png'

const getColorByStatusCor = (statusCor) => {
  switch (statusCor) {
    case 'VERDE':
      return '#27ae60'
    case 'VERMELHO':
      return '#fa3434'
    case 'AMARELO':
      return '#ffa500'
    default:
      return '#8f8f8f'
  }
}

export const Wrapper = styled.div`
  text-align: center;
`

export const SteptsList = styled.ul`
  counter-reset: steps;
  padding: 0;
  margin: 55px 0 20px 10px;
  list-style: none;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const StepsItem = styled.li`
  ${({ ativo, cancelado, inicial, entregue, cores }) => css`
    counter-increment: steps;
    display: grid;
    width: 110px;
    margin: 0 20px;

    ${inicial &&
    css`
      .StepLinhaAnterior {
        display: none;
      }
    `}

    .StepEtapas {
      display: flex;
      position: relative;
      justify-content: center;
    }

    .StepLinhaAnterior {
      width: 60px;
      height: 4px;
      background: #afaeae;
      position: absolute;
      top: 14px;
      left: -20px;
    }

    .StepLinhaPosterior {
      width: 60px;
      height: 4px;
      background: #afaeae;
      position: absolute;
      top: 14px;
      left: 70px;
    }
    .StepPosicao {
      width: 32px;
      height: 32px;
      display: flex;
      font-weight: 600;
      align-items: center;
      justify-content: center;
      content: '';
      background: #ffffff;
      border-radius: 50%;
      border: 3px solid #afaeae;
    }

    .Informacao {
      width: 110px;
      text-align: center;
      margin: 10px 0 0 0;
    }
    .Informacao p {
      margin: 0;
      padding: 0;
    }

    .Informacao p.Chamada {
      line-height: 14px;
      font-weight: 600;
      font-size: 12px;
      color: #afaeae;
      margin: 3px 0 5px 0;
    }

    .Informacao p.LinkAcesso {
      margin: 5px 0 0 0;
      line-height: 12px;
      font-size: 12px;
      color: #afaeae;
      height: 16px;
    }

    .Informacao p.LinkAcesso a {
      background-color: ${getColorByStatusCor(cores)};
      text-decoration: none;
      color: #ffffff;
      padding: 2px 8px;
      border-radius: 3px;
      font-size: 10px;
      letter-spacing: 1px;
      cursor: pointer;
    }

    .Informacao p.DataHora {
      font-weight: 500;
      color: #afaeae;
      font-size: 12px;
      margin: 4px 0 0 0;
      height: 15px;
    }

    .Informacao p.Motivo {
      background-color: unset;
      color: ${getColorByStatusCor(cores)};
      font-weight: 700;
      font-size: 10px;
    }

    //Passo 6 Inativo
    ${entregue &&
    css`
      width: 120px;
      .Informacao {
        width: 90px;
        padding: 0 10px;
        margin: 4px 0 0 0;
      }
      .StepPosicao {
        background-image: url(${IconAguardandoEntrega});
        background-size: 29px;
        background-repeat: no-repeat;
        background-position: center;
        width: 45px;
        height: 45px;
        margin: -4px 0 0 0px;
      }
      .StepLinhaPosterior {
        display: none;
      }

      .Informacao {
        width: 120px;
      }

      @media (max-width: 768px) {
        .StepPosicao {
          margin: -1px 0 0px -7px;
        }
        .Informacao {
          margin: 12px 0 0 -2px !important;
        }
        &:last-child {
          margin: -18px 0 10px 0px;
        }
      }
    `}

    //Passos ativos
    ${ativo &&
    css`
      .StepEtapas {
        .StepPosicao {
          background-color: ${getColorByStatusCor(cores)};
          border: 3px solid ${getColorByStatusCor(cores)};
        }
        .StepPosicao:before {
          font-size: 20px;
          line-height: 26px;
          color: white;
        }
        .StepLinhaAnterior {
          background: ${getColorByStatusCor(cores)};
        }

        .StepLinhaPosterior {
          background: ${getColorByStatusCor(cores)};
        }
      }

      .Informacao {
        width: 110px;
      }

      .Informacao p.Chamada {
        color: ${getColorByStatusCor(cores)};
      }

      .Informacao p.LinkAcesso a {
        background-color: ${getColorByStatusCor(cores)};
      }
      ${cores === 'VERMELHO' &&
      css`
        .StepPosicao:before {
          content: 'X';
        }
      `}
      ${cores === 'VERDE' &&
      css`
        .StepPosicao:before {
          content: '✔';
        }
      `}
      ${cores === 'AMARELO' &&
      css`
        .StepPosicao:before {
          content: '!';
        }
      `}
      //Passos ativos e entregue
      ${entregue &&
      css`
        .StepPosicao {
          background-image: url(${IconEntregaEfetuada});
          background-size: 46px;
          background-repeat: no-repeat;
          background-position: center;
          width: 45px;
          height: 45px;
          margin: -4px 0 0 0px;

          &:before {
            content: '';
            font-size: 0px !important;
          }
        }
        //Checa se ultimo step (entregue) a cor é vermelho
        ${cores === 'VERMELHO' &&
        css`
          .StepPosicao {
            background-image: unset;

            &:before {
              content: 'X';
              font-size: 24px !important;
            }
          }
        `}
        //Checa se ultimo step (entregue) a cor é vermelho
          ${cores === 'AMARELO' &&
        css`
          .StepPosicao {
            background-image: unset;

            &:before {
              content: '!';
              font-size: 24px !important;
            }
          }
        `}

          @media (max-width: 768px) {
          .StepPosicao {
            margin: -1px 0 0px -7px !important;
          }
          .Informacao {
            margin: 12px 0 0 -2px !important;
          }
          &:last-child {
            margin: -18px 0 10px 0px;
          }
        }
      `}
    `}

    @media (max-width: 980px) {
      .StepLinhaAnterior {
      }
      .StepLinhaPosterior {
      }
    }

    @media (max-width: 768px) {
      margin: -18px 0 34px 0px;
      display: flex;
      width: -webkit-fill-available;

      .Informacao {
        width: -webkit-fill-available;
        text-align: left;
        margin: 9px 0 0 17px;
      }

      .StepLinhaAnterior {
        width: 26px;
        left: 3px;
        -webkit-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
        top: -15px;
      }
      .StepLinhaPosterior {
        width: 26px;
        left: 3px;
        -webkit-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
        top: 42px;
      }
      ${ativo &&
      css`
        width: -webkit-fill-available;
        .StepPosicao {
          margin: 0 0 0 0;
        }
        .Informacao {
          width: -webkit-fill-available;
          margin: 6px 0 0 16px;
        }

        @media (max-width: 768px) {
          margin: -18px 0 37px 0px;
        }
      `}
    }
  `}
`
